<template>
  <MainLayout>
    <!-- Orders Sub Navigation -->
    <OrdersSubNavbar />

    <div class="space-y-4 sm:space-y-6 px-3 sm:px-6">
      <!-- Header -->
      <PageHeader
        title="Costos de Envío a Domicilio"
        subtitle="Configura reglas personalizadas para costos de domicilio"
      >
        <template #actions>
          <BaseButton
            variant="primary"
            @click="openCreateRuleModal"
          >
            <template #icon>
              <PlusIcon
                class="h-5 w-5"
                aria-hidden="true"
              />
            </template>
            Nueva Regla
          </BaseButton>
        </template>
      </PageHeader>

      <!-- Content -->
      <DeliveryFeeRules ref="deliveryFeeRulesRef" />
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { PlusIcon } from '@heroicons/vue/24/outline';
import DeliveryFeeRules from '@/components/settings/DeliveryFeeRules.vue';
import OrdersSubNavbar from '@/components/orders/OrdersSubNavbar.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import PageHeader from '@/components/layout/PageHeader.vue';
import BaseButton from '@/components/ui/BaseButton.vue';

const deliveryFeeRulesRef = ref<InstanceType<typeof DeliveryFeeRules> | null>(null);

const openCreateRuleModal = () => {
  deliveryFeeRulesRef.value?.openCreateModal();
};
</script>
